export class BlogModel {
    id: number;
    title: string;
    titleImage: string;
    date: string;
    content: string;
    content_substring: string;
    hashtags: string;
    is_hover: boolean;

    constructor() {
        this.id = 0;
        this.title = '';
        this.titleImage = '';
        this.content = '';
        this.content_substring = '';
        this.hashtags = '';
        this.date = '';
        this.title = '';
        this.is_hover = false;
    }

    RemoveHtmlTags(input: string): string {
        if (input != null && input.length > 0) return input.replace(/<[^>]*>/g, '');
        else return '';
    }
}